export enum AggregateFunction {
  Average = 'Avg',
  Sum = 'Sum',
  Minimum = 'Min',
  Maximum = 'Max',
  LotAverage = 'LotAvg'
}
